// extracted by mini-css-extract-plugin
export var divider = "_22-0";
export var dividerText = "_22-1";